// /opt/isp_erp/frontend/src/components/warehouse/TipoFallaSelect.jsx
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

export const TIPOS_FALLA = [
  { value: 'FISICO', label: 'Daño físico (golpes, puertos, carcasa)' },
  { value: 'ELECTRONICO', label: 'Falla electrónica (no enciende, fuente, placa)' },
  { value: 'FIRMWARE', label: 'Falla de firmware o configuración' },
  { value: 'CONEXION', label: 'Falla de conexión (señal, puertos de red, fibra)' },
  { value: 'OTRO', label: 'Otra falla' }
];

const TipoFallaSelect = ({ value, onChange, required = false }) => (
  <FormControl fullWidth sx={{ mt: 2 }} error={required && !value}>
    <InputLabel>{required ? 'Tipo de falla *' : 'Tipo de falla'}</InputLabel>
    <Select
      value={value || ''}
      label={required ? 'Tipo de falla *' : 'Tipo de falla'}
      onChange={(e) => onChange(e.target.value)}
    >
      {TIPOS_FALLA.map((t) => (
        <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>
      ))}
    </Select>
    {required && !value && <FormHelperText>Selecciona el tipo de falla</FormHelperText>}
  </FormControl>
);

export default TipoFallaSelect;
